import requets from '@/utils/request'

export function tekrar (istek) {
  return requets(istek)
}

export function oturumYenile (refreshToken) {
  return requets({
    url: 'auth/oturumYenile',
    method: 'GET',
    params: {
      refreshToken
    }
  })
}

export function giris (data) {
  return requets({
    url: 'auth/login',
    method: 'POST',
    data
  })
}

export function girisEPostaKontrol (email) {
  return requets({
    url: 'auth/login-eposta-kontrol',
    method: 'GET',
    params: {
      email
    }
  })
}

export function ePostaKullanimdaMi (ad, soyad, eposta) {
  return requets({
    url: 'auth/eposta-kullanimda-mi',
    method: 'GET',
    params: {
      ad,
      soyad,
      eposta
    }
  })
}

export function telNoKullanimdaMi (ad, soyad, telNo) {
  return requets({
    url: 'auth/tel-no-kullanimda-mi',
    method: 'GET',
    params: {
      ad,
      soyad,
      telNo
    }
  })
}

export function ogrenciKayit (data) {
  return requets({
    url: 'auth/ogrenci-kayit',
    method: 'POST',
    data
  })
}

export function kayit (data) {
  return requets({
    url: 'auth/kayit',
    method: 'POST',
    data
  })
}

export function HesabaGec (guid, tablo) {
  return requets({
    url: 'auth/hesaba-gec',
    method: 'GET',
    params: {
      guid,
      tablo
    }
  })
}

export function sifremiUnuttumEPostaKontrol (email) {
  return requets({
    url: 'auth/sifremi-unuttum-eposta-kontrol',
    method: 'GET',
    params: {
      email
    }
  })
}

export function sifremiUnuttumBirdenFazlaHesapKodYolla (guid) {
  return requets({
    url: 'auth/sifremi-unuttum-birden-fazla',
    method: 'GET',
    params: {
      guid
    }
  })
}

export function sifremiUnuttum (email, guid) {
  return requets({
    url: 'auth/sifremi-unuttum',
    method: 'GET',
    params: {
      email,
      guid
    }
  })
}

export function sifreSifirla (data) {
  return requets({
    url: 'auth/sifre-sifirla',
    method: 'POST',
    data
  })
}

export function sifreSifirlaV2 (data) {
  return requets({
    url: 'auth/sifre-sifirla',
    method: 'POST',
    data
  })
}

export function bilgilerimiGetirV2 () {
  return requets({
    url: 'auth/bilgilerimi-getir-v2',
    method: 'GET'
  })
}

export function bilgilerimiGuncelleV2 (data) {
  return requets({
    url: 'auth/bilgilerimi-guncelle-v2',
    method: 'PUT',
    data
  })
}

export function bilgilerimiGetir () {
  return requets({
    url: 'auth/bilgilerimi-getir',
    method: 'GET'
  })
}

export function bilgilerimiGuncelle (data) {
  return requets({
    url: 'auth/bilgilerimi-guncelle',
    method: 'PUT',
    data
  })
}

export function hesabimiSil () {
  return requets({
    url: 'auth/hesabimi-sil',
    method: 'GET'
  })
}
